import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useLocalStorageUncontrolled } from '../../../hooks/useLocalStorageUncontrolled'
import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'
import { SALES_REPORT_ROUTE_STORAGE_KEY } from '../constants/salesReportRouteStorageKey'
import { isSalesReportRouteValid } from '../utils/isSalesReportRouteValid'

export const useSalesReportRoutes = () => {
  const { getItem } = useLocalStorageUncontrolled(SALES_REPORT_ROUTE_STORAGE_KEY)
  const previousSalesReportRoute = getItem()
  const { organization } = useUserOrganization()

  const salesReportEmptyUrl = useMemo(
    () => getOrganizationViewUrl(organization?.url, reactRoute.organization.salesReport.getListEmptyRoute()),
    [organization?.url],
  )
  const salesReportMainUrl = useMemo(
    () => getOrganizationViewUrl(organization?.url, reactRoute.organization.salesReport.getMainRoute()),
    [organization?.url],
  )
  const salesReportOverviewUrl = useMemo(
    () => getOrganizationViewUrl(organization?.url, reactRoute.organization.salesReport.getSalesOverviewRoute()),
    [organization?.url],
  )

  const defaultSalesReportUrl = salesReportOverviewUrl

  const fallbackSalesReportUrl =
    previousSalesReportRoute && isSalesReportRouteValid(previousSalesReportRoute, organization?.url)
      ? previousSalesReportRoute
      : defaultSalesReportUrl

  return { fallbackSalesReportUrl, salesReportEmptyUrl, salesReportMainUrl }
}
